import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ConnectivityService } from '@klickdata/core/application';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-connection-alert',
    templateUrl: './connection-alert.component.html',
    styleUrls: ['./connection-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectionAlertComponent {
    public offline$: Observable<boolean>;

    constructor(protected connectivity: ConnectivityService) {
        this.offline$ = this.connectivity.offline$;
    }
}
